import { Component, Input } from '@angular/core';
import { FilterSummaryItem } from 'app/_utils/filter-summary.utils';

@Component({
  selector: 'filter-summary-display',
  templateUrl: './filter-summary-display.component.html',
})
export class FilterSummaryDisplayComponent {
  @Input() items: FilterSummaryItem[] = [];
}
